import { useEffect, useRef } from 'react';

import lottie, { AnimationItem } from 'lottie-web';

import loadingAnimation from '../assets/lotties/dashboard-loading-animation.json';

export interface LoadingAnimationProps {
  className?: string;
}

export default function LoadingAnimation({ className }: LoadingAnimationProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<AnimationItem | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Destroy existing animation if it exists
    if (animationRef.current) {
      animationRef.current.destroy();
    }

    try {
      animationRef.current = lottie.loadAnimation({
        container: containerRef.current,
        animationData: loadingAnimation,
        renderer: 'svg',
        loop: true,
        autoplay: true,
      });
    } catch (error) {
      console.error('Failed to load Lottie animation:', error);
      return;
    }

    // Cleanup function to destroy Lottie animation and prevent memory leaks on unmount
    return () => {
      if (animationRef.current) {
        animationRef.current.destroy();
        animationRef.current = null;
      }
    };
  }, []);

  return <div ref={containerRef} className={className} />;
}
